import {viewerService} from '../viewer-service';
import {Sanitizer} from './sanitizer';

export const sanitizer = new Sanitizer(viewerService.viewer.checkLightBoxTextWidth);